import React,{useRef} from "react";
import './Contact.css';
import emailjs from '@emailjs/browser';

const Contact=()=>{
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_64oatb8', 'template_zplmlrj', form.current, 'XRhDqiymLBDqBkgX2')
      .then((result) => {
          console.log(result.text);
          console.log("Message Sent");
          alert("Thankyou for Reaching Out Your Message is Sent Successfully!..We'll Contact you soon");
      }, (error) => {
          console.log(error.text);
          console.log("Message Not Sent");
      });
  };
    return <>
      <div className="row justify-content-center pt-5 pb-5" id="contact">
    <div className="col-xl-10">
      <div className="card border-0 rounded-3 shadow-lg overflow-hidden">
        <div className="card-body p-0">
          <div className="row g-0">
            <div className="col-sm-6 d-none d-sm-block bg-image"></div>
            <div className="col-sm-6 p-4">
              <div className="text-center">
                <div className="h3 fw-light">Contact Form</div>
                {/* <p className="mb-4 text-muted">Split layout contact form</p> */}
              </div>
              <form id="contactForm" ref={form} data-sb-form-api-token="API_TOKEN" method="post"
              onSubmit={sendEmail}>
                <div className="form-floating mb-3">
                  <input className="form-control" id="name" type="text" name="user_name" placeholder="Name" data-sb-validations="required" />
                  <label for="name">Name</label>
                  <div className="invalid-feedback" data-sb-feedback="name:required">Name is required.</div>
                </div>
                <div className="form-floating mb-3">
                  <input className="form-control" id="emailAddress" type="user_email" name="Email" placeholder="Email Address" data-sb-validations="required,email" />
                  <label for="emailAddress">Email Address</label>
                  <div className="invalid-feedback" data-sb-feedback="emailAddress:required">Email Address is required.</div>
                  <div className="invalid-feedback" data-sb-feedback="emailAddress:email">Email Address Email is not valid.</div>
                </div>
                <div className="form-floating mb-3">
                  <textarea className="form-control" id="message" type="text" name="message" placeholder="Message" style={{height: "10rem;"}} data-sb-validations="required"></textarea>
                  <label for="message">Message</label>
                  <div className="invalid-feedback" data-sb-feedback="message:required">Message is required.</div>
                </div>
                <div className="d-none" id="submitSuccessMessage">
                  <div className="text-center mb-3">
                    <div className="fw-bolder">Form submission successful!</div>
                    <p>To activate this form, sign up at</p>
                    <a href="https://startbootstrap.com/solution/contact-forms">https://startbootstrap.com/solution/contact-forms</a>
                    </div>
                </div>
                <div className="d-none" id="submitErrorMessage">
                  <div className="text-center text-danger mb-3">Error sending message!</div>
                </div>
                <div className="d-grid" style={{width: "10rem;"}}>
                  <button className="btn btn-primary btn-lg  button" id="submitButton" type="submit" value="send"  >Submit</button>
                </div>
              </form>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>



    </>
}
export default Contact;